module.exports = __webpack_public_path__ + "static/media/elfsight-widgets-logo.1870db9c.png";